import { Label } from '@ttab/elephant-ui'
import { useTranslation } from 'react-i18next'
import { DocumentHistory } from '@/components/DocumentHistory/DocumentHistory'
import type { StatusHistoryEntry } from '@/components/DocumentHistory/lib/buildStatusHistory'
import { useModal } from '@/components/Modal/useModal'
import { PreviewSheet } from '@/components/PreviewSheet'

export const StatusHistory = ({ documentId, documentType }: {
  documentId: string
  documentType?: string
}) => {
  const { t } = useTranslation('metaSheet')
  const { showModal, hideModal } = useModal()

  const openPreview = (entry: StatusHistoryEntry) => {
    showModal(
      <PreviewSheet
        id={documentId}
        version={entry.version}
        versionInfo={{ ...entry, documentType }}
        textOnly={false}
        handleClose={hideModal}
      />,
      'sheet',
      { id: documentId }
    )
  }

  return (
    <>
      <Label htmlFor='history' className='text-xs text-muted-foreground -mb-3'>
        {t('labels.history')}
      </Label>

      <div id='history'>
        <DocumentHistory
          uuid={documentId}
          documentType={documentType}
          source='statuses'
          collapsible={false}
          onSelectEntry={openPreview}
        />
      </div>
    </>
  )
}
